module.exports = __webpack_public_path__ + "img/photo-13.a02d9254.webp";